import React from 'react'
import './Card.css'

const Card = ({
  children,
  title,
  subtitle,
  className = '',
  onClick,
  ...props
}) => {
  return (
    <div
      className={`card ${onClick ? 'card--clickable' : ''} ${className}`}
      onClick={onClick}
      {...props}
    >
      {(title || subtitle) && (
        <div className='card__header'>
          {title && <h3 className='card__title'>{title}</h3>}
          {subtitle && <p className='card__subtitle'>{subtitle}</p>}
        </div>
      )}
      <div className='card__body'>{children}</div>
    </div>
  )
}

export default Card
